"use client";

import { c as _c } from "react/compiler-runtime";
import { clsx } from "clsx";
import NextImage from "next/image";
import { useImageConfiguration } from "@/contexts/image-configuration/image-configuration.context";
import type { ArticleContentModel } from "@/services/api/content/models/article-content-model.types";
import { imageLoader } from "@/utilities/image/image-loader";
type BylineImageProps = {
  readonly url: string;
  readonly fullName: ArticleContentModel.Author["fullName"];
  readonly className?: string;
};
export function BylineImage(t0) {
  const $ = _c(9);
  const {
    url,
    fullName,
    className
  } = t0;
  const {
    serverUrl
  } = useImageConfiguration();
  let t1;
  if ($[0] !== className) {
    t1 = clsx("rounded-full object-cover grayscale", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== serverUrl) {
    t2 = imageLoader(serverUrl);
    $[2] = serverUrl;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== fullName || $[5] !== t1 || $[6] !== t2 || $[7] !== url) {
    t3 = <NextImage alt={fullName} className={t1} fill={true} loader={t2} sizes="50px" src={url} />;
    $[4] = fullName;
    $[5] = t1;
    $[6] = t2;
    $[7] = url;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}